import $ from 'jquery';
import 'magnific-popup';

let offreCommerciale = {
    init() {

        $('.b-mentions .item-mention').each(function () {
            let col_id = parseInt($(this).attr('data-col-id'));
            let nbr = $(this).attr('data-nbr');
            $('.block-tableau-offre-commerciale table th').eq(col_id - 1).children('span:last-child').append('&nbsp;<sup>(' + nbr + ')</sup>');
        });

        $(".form-offre-commerciale input.qte-udc").on('change paste keyup cut select', function () {
            let qte_udc_choice = parseInt($(this).val());
            let id = parseInt($(this).parent().parent().attr('data-id'));
            if (qte_udc_choice >= 0) {
                updateTotalItem(id, qte_udc_choice);
            } else {
                updateTotalItem(id, 0);
            }
        });

        function updateTotalItem(id, qte_udc_choice) {
            let total_unite = qte_udc_choice * parseInt($("#udc_" + id).val());
            $("#total_unite_" + id).val(total_unite);

            let total_item_ht = total_unite * parseFloat($("#price_discount_" + id).val());
            $("#total_item_ht_" + id).val(total_item_ht);

            let total_item_ttc = total_item_ht + (total_item_ht * (parseFloat($("#tva_" + id).val()) / 100));
            $(".total-item-ttc-" + id).text(truncate(total_item_ttc, 2));
            $("#total_item_ttc_" + id).val(truncate(total_item_ttc, 2));

            updateTotal();
            checkFranco();
        }

        function updateTotal() {
            let total_unite = 0;
            let total_ttc = 0;
            let total_ht = 0;

            $('.form-offre-commerciale table tbody tr').each(function () {
                let id = $(this).attr('data-id');
                total_unite += parseInt($("#total_unite_" + id).val());
                total_ttc += parseFloat($("#total_item_ttc_" + id).val());
                total_ht += parseFloat($("#total_item_ht_" + id).val());
            });

            $('#total_unite').val(total_unite);
            $('#total_ttc').val(truncate(total_ttc, 2));
            $('span.total-ttc').text(truncate(total_ttc, 2));
            $('#total_ht').val(truncate(total_ht, 2));
            $('span.total-ht').text(truncate(total_ht, 2));
        }

        function truncate(numToBeTruncated, numOfDecimals) {
            let theNumber = numToBeTruncated.toString();
            let pointIndex = theNumber.indexOf('.');

            // Si pas de point, ajouter ".00"
            if (pointIndex === -1) return theNumber + ".00";

            // Calculer le nombre de décimales actuelles
            let decimalPart = theNumber.split('.')[1] || "";
            let currentDecimals = decimalPart.length;

            // Si le nombre a moins de 2 décimales, compléter avec des zéros
            if (currentDecimals < 2) {
                return theNumber + "0".repeat(2 - currentDecimals);
            }

            // Tronquer sans arrondir
            return theNumber.slice(0, pointIndex + numOfDecimals + 1);
        }

        function checkFranco() {
            if ($('#type_franco').length > 0) {
                let disabled = true;
                if ($('#type_franco').val() == '1') {
                    //franco unité
                    let seuil = parseInt($("#montant_franco").val());
                    if (parseInt($('#total_unite').val()) >= seuil) {
                        disabled = false;
                    }
                } else {
                    //Franco prix
                    let seuil = parseFloat($("#montant_franco").val());
                    if (parseFloat($('#total_ttc').val()) >= seuil) {
                        disabled = false;
                    }
                }

                if (disabled) {
                    $("input.submit").attr('disabled', 'disabled');
                } else {
                    $("input.submit").removeAttr('disabled');
                }
            } else if (parseFloat($('#total_ttc').val()) > 0) {
                $("input.submit").removeAttr('disabled');
            } else {
                $("input.submit").attr('disabled', 'disabled');
            }

        }

        let alwaysSubmit = false;
        //Validation form recap offre
        $(document).on('submit', '.form-offre-commerciale', function (event) {
            event.preventDefault();
            if (!alwaysSubmit) {
                let formData = $(this).serializeArray();
                let items = [];
                $('.form-offre-commerciale table tbody tr').each(function () {
                    let id = $(this).attr('data-id');
                    items.push(id);
                });
                formData.push({name: 'items', value: items});
                $.ajax({
                    method: "POST",
                    url: '/ekko-offres-commerciales/show-recapitulatif',
                    data: formData,
                    dataType: "html",
                    beforeSend: function () {
                        alwaysSubmit = true;
                        //Afficher le loader
                        $('body').after(Drupal.theme.ajaxProgressIndicatorFullscreen());
                    },
                    success: function (data, status) {
                        $(this).magnificPopup({
                            items: {
                                src: data,
                            },
                            overflowY: 'auto',
                            mainClass: 'mfp-fade',
                            midClick: true,
                            closeOnBgClick: false
                        }).magnificPopup('open');
                    },
                    complete: function () {
                        alwaysSubmit = false;
                        //Cacher le loader
                        $(".ajax-progress-fullscreen").remove();
                    },
                    error: function (data, status) {
                        console.log(data, status);
                    }
                });
            }


        });

        //Validation form validate offre
        $(document).on('submit', '.form-recap-offre-commerciale', function (event) {
            event.preventDefault();
            if (!alwaysSubmit) {
                let formData = $(this).serializeArray();
                let items = [];
                $('.form-recap-offre-commerciale table tbody tr').each(function () {
                    let id = $(this).attr('data-id');
                    items.push(id);
                });
                formData.push({name: 'items', value: items});
                $.ajax({
                    method: "POST",
                    url: '/ekko-offres-commerciales/valid-offre',
                    data: formData,
                    dataType: "html",
                    beforeSend: function () {
                        alwaysSubmit = true;
                        //Afficher le loader
                        $('body').after(Drupal.theme.ajaxProgressIndicatorFullscreen());
                    },
                    success: function (data, status) {
                        $(this).magnificPopup({
                            items: {
                                src: data,
                            },
                            overflowY: 'auto',
                            mainClass: 'mfp-fade',
                            midClick: true,
                            closeOnBgClick: false
                        }).magnificPopup('open');
                    },
                    complete: function () {
                        alwaysSubmit = false;
                        //Vider la tableau en dessous
                        $('.form-offre-commerciale input.qte-udc').each(function () {
                            $(this).val(0);
                            let id = parseInt($(this).parent().parent().attr('data-id'));
                            updateTotalItem(id, 0);
                        });

                        //Cacher le loader
                        $(".ajax-progress-fullscreen").remove();
                    },
                    error: function (data, status) {
                        console.log(data, status);
                    }
                });
            }
        });

        // Check disabled form recap
        $(document).on('change', '.form-recap-offre-commerciale #cgv', function () {
            if ($(this).is(':checked')) {
                $('.form-recap-offre-commerciale .b-actions input').removeAttr('disabled');
            } else {
                $('.form-recap-offre-commerciale .b-actions input').attr('disabled', 'disabled');
            }
        });

        //Close popup
        $(document).on('click', '.form-recap-offre-commerciale button.reset', function (event) {
            event.preventDefault();
            $.magnificPopup.close();
        });


    }
}

export default offreCommerciale;
